import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function Utilities() {
  return (
    <div
      className='md:mt-20 mt-10'
      id='utilities'
    >
      <AnimateOnScroll animation='flipIn'>
        <div className='bg-black mx-auto border border-[#FFFFFF1F] text-[#FF8A3D] text-center rounded-full w-28 py-2 px-5'>
          <h5>UTILITIES</h5>
        </div>
      </AnimateOnScroll>
      <AnimateOnScroll animation='flipIn'>
        <h1 className='md:text-5xl text-3xl font-semibold text-center'>
          Tools AI Introduction
        </h1>
      </AnimateOnScroll>
      <div className='box_shadow md:p-16 p-10 rounded-[38px] border border-[#20202014] mt-10'>
        <AnimateOnScroll animation='flipIn'>
          <div>
            <img
              src='/images/volum.png'
              alt='volum'
              className='w-14 h-14'
            />
          </div>
        </AnimateOnScroll>
        <AnimateOnScroll animation='flipIn'>
          <h3 className='md:text-3xl text-xl mt-4 font-semibold'>
            Volume (FOMO) Analyzer{' '}
          </h3>
        </AnimateOnScroll>
        <div className='grid lg:grid-cols-2 grid-cols-1 md:gap-5 gap-10 mt-8'>
          <div className='space-y-2'>
            <AnimateOnScroll animation='flipIn'>
              <h6 className='text-[#66CEEC]'>1. FOMO Alert:</h6>
            </AnimateOnScroll>
            <AnimateOnScroll animation='flipIn'>
              <p>
                This feature monitors projects on the ETH network, detecting &
                notifying users about increasing transaction volumes. Users
                receive immediate notifications with detailed token overviews &
                top token holders' distribution. Post-launch, this feature will
                also be available on the Solana chain.
              </p>
            </AnimateOnScroll>
          </div>
          <div className='space-y-2'>
            <AnimateOnScroll animation='flipIn'>
              <h6 className='text-[#66CEEC]'>2. Security Scan:</h6>
            </AnimateOnScroll>
            <AnimateOnScroll animation='flipIn'>
              <p>
                Our bot evaluates the safety of tokens, providing a security
                rating to guide users (note: users should always perform their
                due diligence). The bot offers comprehensive security analysis &
                detailed contract address (CA) information, ensuring you are
                well-informed before making any trades.
              </p>
            </AnimateOnScroll>
          </div>
        </div>
      </div>
      <div className='grid lg:grid-cols-2 grid-cols-1 md:gap-5 gap-10 mt-8'>
        <div className='space-y-4 box_shadow rounded-[38px] border border-[#20202014] md:p-16 p-10'>
          <AnimateOnScroll animation='flipIn'>
            <div>
              <img
                src='/images/tools.png'
                alt='tools'
                className='w-14 h-14'
              />
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <h3 className='md:text-3xl text-xl font-medium'>ToolsAI Eyes </h3>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <p>
              An advanced AI-powered feature that analyzes messages in real-time
              to identify & flag potential Fear, Uncertainty, & Doubt (FUD)
              content. It enhances community confidence by swiftly removing
              users who join the group with fake contract addresses or links as
              names, maintaining the integrity of your group. It also has an
              option to automatically delete proposals. All these features can
              be toggled on/off by the group admin.
            </p>
          </AnimateOnScroll>
        </div>
        <div className='space-y-4 box_shadow rounded-[38px] border border-[#20202014] md:p-16 p-10'>
          <AnimateOnScroll animation='flipIn'>
            <div>
              <img
                src='/images/notifecation.png'
                alt='notifecation'
                className='w-14 h-14'
              />
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <h3 className='md:text-3xl text-xl font-medium'>
              Token Burn Notification
              <br />
              <span className='font-light text-base'>(Coming Soon)</span>
            </h3>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <p>
              This feature will notify users about token burns and liquidity
              burns conducted by projects, ensuring you are always up-to-date
              with the latest burn activities. Burn events are critical as they
              often impact token supply and value, providing crucial information
              for traders.
            </p>
          </AnimateOnScroll>
        </div>
      </div>
    </div>
  )
}
